// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"3374e5d2","313":"6920c4ff","626":"20cb5b65","780":"d9700581","954":"7aeec6a0"}[chunkId] + ".css";
};